import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CompanyPageStepPlanComponent } from './company-page-step-plan.component';

@NgModule({
  declarations: [CompanyPageStepPlanComponent],
  imports: [CommonModule, FormsModule],
  exports: [CompanyPageStepPlanComponent],
  entryComponents: [CompanyPageStepPlanComponent]
})
export class CompanyPageStepPlanModule { }
